import React from 'react'
import ReportHeader from '../../../common/ReportHeader'
import { Box, Typography } from '@mui/material'

const TrackTopupDetails = () => {

    const columnDef = [
        { label: "Franchisee Code", value: 'VISH' },
        { label: "Franchisee Name", value: 'TESTING FRANCHISE' },
        { label: "Bus Station Name", value: 'KEMPE GOWDA B.S.' },
        { label: "Depot Name", value: 'BENGALURU CENTRAL' },
        { label: "Division Name", value: 'BENGALURU CENTRAL' },
        { label: "Corporation Name", value: 'KSRTC' },
        { label: "IP Address", value: '183.83.146.189' },
        { label: "Remarks", value: 'Online Topup from Kotak bank' },
        { label: "Receipt No/Date", value: 'KBS-TTMCFR-43 18-Sep-2024' },

    ]

    const columnDef1 = [
        { label: "OB Reference No.", value: 'OB18831312' },
        { label: "Ticket No.", value: '676535' },
        { label: "Top Up Created  Date", value: '18-09-2024 | 20:22' },
        { label: "Top Up Amount", value: '5000' },
        { label: "Payment Mode", value: 'Kotak Razorpay' },
        { label: "PG Txn. Status", value: 'Success' },
        { label: "PG Txn. Id", value: 'pay_OyZxLPBzC9EVTC' },
        { label: "Topup Status", value: 'Success' },
    ]

    const labelStyle = {
        fontWeight: "500",
        fontStyle: "Medium",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "2%",
        color: '#202020'

    }

    const succeslabel = {
        fontWeight: "700",
        fontStyle: "Bold",
        fontSize: "18px",
        lineHeight: "20px",
        letterSpacing: "2%",
        textTransform: "uppercase",
        color: '#3C763C'
    }
    return (
        <Box sx={{ padding: '12px 16px' }}>
            <ReportHeader mainHeaderName={"Top up details"} headerName={""} mainMenuOpen={false} />
            <Box sx={{ display: 'flex', padding: '20px 16px', gap: '40px', border: ' 1px solid rgba(0, 0, 0, 0.1019607843)' }}>
                <Box sx={{ width: '50%', borderRight: "1px solid #004F9E", display: 'flex', flexDirection: 'column', gap: "12px" }}>
                    {columnDef.map((obj) => (
                        <Box sx={{ display: 'flex', gap: '8px', alignItems: 'start' }}>
                            <Typography sx={{ ...labelStyle, width: '40%' }}>{obj.label}</Typography>
                            <Typography sx={{ ...labelStyle }}>:</Typography>
                            <Typography sx={{ ...labelStyle }}>{obj.value}</Typography>
                        </Box>
                    ))}
                </Box>
                <Box sx={{ width: '50%', display: 'flex', flexDirection: 'column', gap: "12px" }}>
                    {columnDef1.map((obj) => (
                        <Box sx={{ display: 'flex', gap: '8px', alignItems: 'start' }}>
                            <Typography sx={{ ...labelStyle, width: '40%' }}>{obj.label}</Typography>
                            <Typography sx={{ ...labelStyle }}>:</Typography>
                            <Typography sx={{ ...labelStyle, ...(['PG Txn. Status', 'Topup Status'].includes(obj.label) ? succeslabel : {}) }}>{obj.value}</Typography>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    )
}

export default TrackTopupDetails